var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('element-generator',{attrs:{"loading":_vm.loading,"isShowAllButtonEnabled":_vm.isShowAllButtonEnabled,"title":_vm.title,"elementId":_vm.gridView ? 1 : 2,"items":_vm.items,"itemType":_vm.itemType,"elementWidth":_vm.elementWidth},on:{"onViewAllButtonClick":function($event){return _vm.$emit('onViewAllClick')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }